import spec from 'src/assets/onward_api.yml';
import SwaggerUI from 'swagger-ui-react';
import 'swagger-ui-react/swagger-ui.css';

const Documentation = () => {
    return <SwaggerUI url={spec} />;
};

export default Documentation;
